<template>
    <v-toolbar class="mb-4 welcome" flat>
        <v-toolbar-title>{{ getWelcomeMessage }}</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
import auth from '../../../js/auth';

export default {
    name: 'home-welcome',
    computed: {
        getWelcomeMessage() {
            let user = auth.getUser();
            let date = new Date();
            let hour = date.getHours();

            if (hour >= 12 && hour < 18) {
                return `Good afternoon, ${user.commonName}.`;
            } else if (hour >= 18 && hour < 24) {
                return `Good evening, ${user.commonName}.`;

            }

            return `Good morning, ${user.commonName}.`;
        }
    }
}
</script>

<style scoped>
.v-toolbar {
    background: transparent !important;
}

.welcome {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: .0073529412em!important;
}
</style>